import React from 'react'
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify'
import { useFetch } from '../../../../hooks'
import Button from '../../../../components/inputs/Button'
import Buttons from '../../../../modules/Buttons'
import ToastRemoveUndo from '../../../../components/toasts/ToastRemoveUndo'
import { FormHeader, FormBodyText, Form } from '../../../../modules/Form/styled'
import { pathOr } from 'ramda';

const FormRemove = ({ data, url, urlUndo, redirect, onClickCancel, translation }) => {
    const history = useHistory();

    const { fetching, doFetch } = useFetch({
        url,
        method: 'POST'
    })

    const handleSubmit = async (event) => {
        event.preventDefault()
        const response = await doFetch({ data });
        const isError = pathOr(false, ['error'], response);
        const message = pathOr(null, ['msg'], response);
        if (isError || response === 0) {
            const messageError = message || pathOr(null, ['error'], translation);
            messageError && toast.error(messageError)
        } else {
            if (urlUndo) {
                toast(<ToastRemoveUndo
                    data={data}
                    url={urlUndo}
                    redirect={redirect}
                    history={history}
                    translation={{
                        buttons: pathOr(null, ['buttons'], translation),
                        'info-confirm': message || pathOr(null, ['info-confirm'], translation)
                    }}
                />);
            } else {
                message && toast.success(message);
            }
            history.push(redirect || '/manage');
        }
    }
    return (
        <Form onSubmit={handleSubmit}>
            <FormHeader>
                {translation && translation.title}
            </FormHeader>
            <FormBodyText>
                {translation && translation.info}
            </FormBodyText>
            <Buttons>
                <Button
                    type='submit'
                    fullWidth
                    red
                    disabled={fetching}
                >
                    {translation && translation.buttons.save}
                </Button>
                <Button
                    type='button'
                    fullWidth
                    onClick={onClickCancel}
                >
                    {translation && translation.buttons.cancel}
                </Button>
            </Buttons>
        </Form>
    )
}

export default FormRemove
